import { render, staticRenderFns } from "./project.vue?vue&type=template&id=1dae0bd2"
import script from "./project.ts?vue&type=script&lang=ts&external"
export * from "./project.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports